const colors = {
    red: "#ee7b6b",
    blue: "#7ca3de",
    green: "#69c871",
    orange: "#f0a26e",
    yellow: "#d1c300"
}
const role = {
    ADM: "ADM",
    Franchisee: "franchisee",
}

export const StatusReference = {
    // Prospec
    101: { name: "Reprovada", color: colors.red, role: role.ADM, etapa: "Prospec" },
    102: { name: "Em revisão", color: colors.yellow, role: role.ADM, etapa: "Prospec" },
    103: { name: "Prospecção Aprovado", color: colors.green, role: role.ADM, etapa: "Prospec" },
    104: { name: "Analise Solicitada", color: colors.orange, role: role.ADM, etapa: "Prospec", slaHours: 48 },
    105: { name: "Rascunho Salvo", color: colors.blue, role: role.ADM, etapa: "Prospec" },

    106: { name: "Reprovada", color: colors.red, role: role.Franchisee, etapa: "Prospec" },
    107: { name: "Revisão Solicitada", color: colors.orange, role: role.Franchisee, etapa: "Prospec" },
    108: { name: "Prospecção Aprovada", color: colors.green, role: role.Franchisee, etapa: "Prospec" },
    109: { name: "Analise em andamento", color: colors.yellow, role: role.Franchisee, etapa: "Prospec" },
    110: { name: "Rascunho Salvo", color: colors.blue, role: role.Franchisee, etapa: "Prospec" },

    // Waterscan
    201: { name: "Reprovado", color: colors.red, role: role.ADM, etapa: "Waterscan" },
    202: { name: "Em revisão", color: colors.yellow, role: role.ADM, etapa: "Waterscan" },
    203: { name: "Waterscan Aprovado", color: colors.green, role: role.ADM, etapa: "Waterscan" },
    204: { name: "Analise Solicitada", color: colors.orange, role: role.ADM, etapa: "Waterscan", slaHours: 96 },
    205: { name: "Rascunho Salvo", color: colors.blue, role: role.ADM, etapa: "Waterscan" }, 
    206: { name: "Waterscan Liberado", color: colors.green, role: role.ADM, etapa: "Waterscan" },

    207: { name: "Reprovado", color: colors.red, role: role.Franchisee, etapa: "Waterscan" },
    208: { name: "Revisão Solicitada", color: colors.orange, role: role.Franchisee, etapa: "Waterscan" },
    209: { name: "Waterscan Aprovado", color: colors.green, role: role.Franchisee, etapa: "Waterscan" },
    210: { name: "Analise em andamento.", color: colors.yellow, role: role.Franchisee, etapa: "Waterscan" },
    211: { name: "Rascunho Salvo", color: colors.blue, role: role.Franchisee, etapa: "Waterscan" },
    212: { name: "Waterscan Liberado", color: colors.green, role: role.Franchisee, etapa: "Waterscan" },
    
    213: { name: "Waterscan Desatualizado", color: colors.red, role: role.ADM, etapa: "Waterscan" },
    214: { name: "Waterscan Desatualizado", color: colors.red, role: role.Franchisee, etapa: "Waterscan" },

    // Aprovação
    301: { name: "Propostas Liberadas", color: colors.green, role: role.ADM, etapa: "Aprovação" },
    302: { name: "Propostas Pendentes", color: colors.orange, role: role.ADM, etapa: "Aprovação" },

    303: { name: "Propostas Liberadas", color: colors.green, role: role.Franchisee, etapa: "Aprovação" },
    304: { name: "Propostas em Produção", color: colors.yellow, role: role.Franchisee, etapa: "Aprovação" },

    // Fechamento
    401: { name: "Fechamento Liberado", color: colors.green, role: role.ADM, etapa: "Fechamento" },
    402: { name: "Fechamento Liberado", color: colors.green, role: role.Franchisee, etapa: "Fechamento" },

    // Contratos
    501: { name: "Contrato Assinado", color: colors.green, role: role.ADM, etapa: "Contratos" },
    502: { name: "Contrato Aprovado", color: colors.green, role: role.ADM, etapa: "Contratos" },
    503: { name: "Alteração de Contrato", color: colors.orange, role: role.ADM, etapa: "Contratos" },
    504: { name: "Contrato Adicionado", color: colors.yellow, role: role.ADM, etapa: "Contratos" },
    505: { name: "Contrato Solicitado", color: colors.orange, role: role.ADM, etapa: "Contratos" },

    506: { name: "Aguardando Contrato", color: colors.yellow, role: role.Franchisee, etapa: "Contratos" },
    507: { name: "Contrato Disponivel", color: colors.orange, role: role.Franchisee, etapa: "Contratos" },
    508: { name: "Enviado para Assinatura", color: colors.yellow, role: role.Franchisee, etapa: "Contratos" },
    509: { name: "Contrato Assinado", color: colors.green, role: role.Franchisee, etapa: "Contratos" },

    // Entrega
    601: { name: "Itens Recebidos", color: colors.green, role: role.ADM, etapa: "Entrega" },
    602: { name: "Aguardando Recebimento", color: colors.yellow, role: role.ADM, etapa: "Entrega" },
    603: { name: "Expedição Solicitada", color: colors.orange, role: role.ADM, etapa: "Entrega" },

    604: { name: "Aguardando Expedição", color: colors.yellow, role: role.Franchisee, etapa: "Entrega" },
    605: { name: "Itens Enviados", color: colors.orange, role: role.Franchisee, etapa: "Entrega" },
    606: { name: "Itens Recebidos", color: colors.green, role: role.Franchisee, etapa: "Entrega" },

    // Waterfix
    // 607: { name: "Waterfix Liberado", color: colors.green, role: role.ADM, etapa: "Entrega" },
    608: { name: "Rascunho Salvo", color: colors.blue, role: role.ADM, etapa: "Waterfix" },
    609: { name: "Em revisão", color: colors.yellow, role: role.ADM, etapa: "Waterfix" },
    610: { name: "Waterfix Aprovado", color: colors.green, role: role.ADM, etapa: "Waterfix" },
    611: { name: "Analise Solicitada", color: colors.orange, role: role.ADM, etapa: "Waterfix" },

    // 610: { name: "Aguardando Expedição", color: colors.yellow, role: role.Franchisee, etapa: "Entrega" },
    621: { name: "Rascunho Salvo", color: colors.blue, role: role.Franchisee, etapa: "Waterfix" },
    622: { name: "Revisão Solicitada", color: colors.orange, role: role.Franchisee, etapa: "Waterfix" },
    623: { name: "Waterfix Aprovado", color: colors.green, role: role.Franchisee, etapa: "Waterfix" },
    624: { name: "Analise em andamento", color: colors.yellow, role: role.Franchisee, etapa: "Waterfix" },








    // outrs
    2001: { name: "Declinado", color: colors.red, role: role.ADM, etapa: "Manager" },
    2002: { name: "Declinado", color: colors.red, role: role.Franchisee, etapa: "Manager" },

    2003: { name: "Reprovado", color: colors.red, role: role.ADM, etapa: "Manager" },
    2004: { name: "Reprovado", color: colors.red, role: role.Franchisee, etapa: "Manager" },
};

// ============================================================================
// SISTEMA DE NOTIFICAÇÕES - Categorias e Funções Utilitárias
// ============================================================================

/**
 * Função que filtra apenas os status que estão efetivamente em uso no sistema
 * @param {Object} statusReference - Objeto com todos os status
 * @returns {Object} Objeto contendo apenas os status utilizados
 */
function filterUsedStatuses(statusReference) {
    // Lista de códigos de status que estão ativamente em uso
    const usedStatusCodes = [
        // Prospec
        105, 110,
        // Waterscan
        201, 202, 204, 205, 207, 208, 210, 211, 206,
        // Aprovação
        301, 302, 303, 304,
        // Fechamento
        401, 402,
        // Contratos
        501, 503, 504, 505, 506, 507, 509,
        // Waterfix
        608, 609, 610, 611, 621, 622, 623, 624
    ];
    
    const filtered = {};
    usedStatusCodes.forEach(code => {
        if (statusReference[code]) {
            filtered[code] = statusReference[code];
        }
    });
    
    return filtered;
}

/**
 * Constante que armazena apenas os status efetivamente utilizados no sistema
 * Filtrados a partir do StatusReference completo
 */
export const ACTIVE_STATUS_REFERENCE = filterUsedStatuses(StatusReference);

/**
 * Categorias de notificações disponíveis
 * Mapeadas para as etapas existentes no StatusReference
 */
export const NOTIFICATION_CATEGORIES = {
    PROSPECTING: 'Prospec',
    WATERSCAN: 'Waterscan',
    APPROVAL: 'Aprovação',
    CLOSING: 'Fechamento',
    CONTRACTS: 'Contratos',
    MATERIALS: 'Entrega',
    INSTALLATION: 'Waterfix',
};

/**
 * Labels das categorias para exibição na interface
 */
export const NOTIFICATION_CATEGORY_LABELS = {
    [NOTIFICATION_CATEGORIES.PROSPECTING]: 'Prospecção',
    [NOTIFICATION_CATEGORIES.WATERSCAN]: 'WaterScan',
    [NOTIFICATION_CATEGORIES.APPROVAL]: 'Aprovação',
    [NOTIFICATION_CATEGORIES.CLOSING]: 'Fechamento',
    [NOTIFICATION_CATEGORIES.CONTRACTS]: 'Contratos',
    [NOTIFICATION_CATEGORIES.MATERIALS]: 'Entrega de Materiais',
    [NOTIFICATION_CATEGORIES.INSTALLATION]: 'WaterFix',
};

const translateRoles = {
    ADM: "Administrador",
    franchisee: "Franqueado",
}

export const TRANSLATE_STATUS_TO_MESSAGE = {
    105: "O Rascunho da prospecção foi salvo!",//
    110: "O Rascunho da prospecção foi salvo!",//
    201: "O WaterScan foi reprovado!",//
    207: "O WaterScan foi reprovado!",//
    202: "A revisão do WaterScan foi solicitada!",//
    208: "A revisão do WaterScan foi solicitada!",//
    205: "O rascunho do WaterScan foi salvo!",//
    211: "O rascunho do WaterScan foi salvo!",//
    204: "A análise do WaterScan foi solicitada!",//
    210: "A análise do WaterScan foi solicitada!",//
    206: "O WaterScan foi liberado!",//
    301: "As Propostas foram liberadas!",//
    303: "As Propostas foram liberadas!",//
    302: "As Propostas estão pendentes!",//
    304: "As Propostas estão pendentes!",//
    401: "O Fechamento está liberado!",//
    402: "O Fechamento está liberado!",//
    501: "O Contrato foi assinado!",
    509: "O Contrato foi assinado!",
    503: "A alteração do contrato foi solicitada!",
    506: "O contrato está sendo aguardado!",
    504: "O contrato foi assinado!",
    507: "O contrato está disponível!",
    505: "O contrato foi solicitado!",//observar
    506: "O contrato foi solicitado!",//observar
    608: "O rascunho do Waterfix foi salvo!",//
    621: "O rascunho do Waterfix foi salvo!",//
    609: "A revisão do Waterfix foi solicitada!",//bugado
    622: "A revisão do Waterfix foi solicitada!",//bugado
    610: "O Waterfix foi aprovado!",//
    623: "O Waterfix foi aprovado!",//
    611: "A análise do Waterfix foi solicitada!",//
    624: "A análise do Waterfix foi solicitada!",//
}

export function getNotificationStatusesByCategory(category) {
    const statusCodes = Object.keys(ACTIVE_STATUS_REFERENCE)
        .filter(code => ACTIVE_STATUS_REFERENCE[code].etapa === category)
        .map(code => ({
            code: parseInt(code),
            label: `${ACTIVE_STATUS_REFERENCE[code].name} (${translateRoles[ACTIVE_STATUS_REFERENCE[code].role]})`,
            ...ACTIVE_STATUS_REFERENCE[code]
        }));
    
    return statusCodes;
}

export function getCategoryStatusCodes(category) {
    const statuses = getNotificationStatusesByCategory(category);
    return statuses.map(s => s.code);
}
